import { useTelegram } from './useTelegram';
import { readWebSession } from '../lib/webSession';
import { getWebUserId } from '../lib/sessionUser';

/**
 * Whether authenticated API reads/writes may run.
 * TMA: signed initData. Web: stored bearer session (initData empty; authedFetch
 * attaches the token).
 */
export function useAuthReady() {
  const { initData, status, userId: tgUserId } = useTelegram();
  const webSession = !!readWebSession();
  const canFetch = !!initData || webSession;
  // Prefer Telegram numeric id for cache keys; on web use server user id only
  // (no shared 'web' fallback — avoids cross-account cache bleed before /me).
  const cacheUserId = tgUserId ?? getWebUserId();
  return {
    canFetch,
    /** Passed to api()/authedFetch — empty string on web (bearer path). */
    initData,
    cacheUserId,
    /** True when running under a browser web session (not Telegram). */
    isWeb: webSession && !initData,
    tgStatus: status,
  };
}
